import type { TrackTrendDto } from '@internal/scorecards-common';
import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { scorecardsApiRef } from '../api/ScorecardsApi';

export function useTeamTrackTrends(team: string): {
  loading: boolean;
  error?: Error;
  trends?: TrackTrendDto[];
} {
  const api = useApi(scorecardsApiRef);
  const [state, setState] = useState<{
    loading: boolean;
    error?: Error;
    trends?: TrackTrendDto[];
  }>({ loading: true });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true });

    api
      .getTeamTrackTrends(team)
      .then(trends => {
        if (!cancelled) setState({ loading: false, trends });
      })
      .catch(err => {
        if (!cancelled)
          setState({
            loading: false,
            error: err instanceof Error ? err : new Error(String(err)),
          });
      });

    return () => {
      cancelled = true;
    };
  }, [api, team]);

  return state;
}
